exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leftArea {\n  flex: 1 1;\n  max-width: 280px;\n  overflow: auto;\n  height: calc(100vh - 56px);\n  background: var(--surface);\n  z-index: 2;\n  position: relative;\n  padding: 24px 0;\n  overflow: hidden; }\n  .leftArea h3 {\n    font-weight: 500;\n    font-size: 14px;\n    margin: 0 0 8px 16px;\n    -webkit-user-select: none;\n            user-select: none;\n    color: var(--onSurfaceStrong); }\n", ""]);

// exports
